import { Info } from 'lucide-react'
import { DirectorDelegationManager } from '@/components/config/DirectorDelegationManager'

export function DirectorDelegationEditor() {
  return (
    <div className="mt-4">
      <div className="flex items-start gap-3 mb-4 p-4 bg-indigo-50 border border-indigo-200 rounded-lg">
        <Info className="w-5 h-5 text-indigo-600 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-indigo-900">
          <p className="font-medium mb-1">Stellvertretungen verwalten</p>
          <p>Hier können Sie festlegen, welche Direktoren andere Direktoren vertreten dürfen. Eine Stellvertretung kann schulweit (ohne Fakultät) oder fakultätsbezogen gelten und zeitlich begrenzt oder dauerhaft sein.</p>
        </div>
      </div>
      <p className="text-sm text-gray-600 italic mb-4">Änderungen an Stellvertretungen werden sofort gespeichert.</p>
      <DirectorDelegationManager />
    </div>
  )
}
